var fe = Object.defineProperty;
var ge = (s, e, t) => e in s ? fe(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var b = (s, e, t) => ge(s, typeof e != "symbol" ? e + "" : e, t);
import { Plugin as P, PluginKey as B, NodeSelection as ee, TextSelection as te, Selection as A } from "prosemirror-state";
import { combineTransactionSteps as we, getMarkRange as ye, posToDOMRect as be, findChildren as _ } from "@tiptap/core";
import ve from "fast-deep-equal";
import { i as K, t as Ce, U as ke, n as xe, g as R, a as N, c as oe, m as Se, e as ne, f as Ee, h as Ie, j as Pe, k as Be, l as Te, o as Y, p as j } from "./blockToNode-BNoNIXU7.js";
import { ai as se, aj as re, $ as De, a1 as X } from "./defaultBlocks-DAhNpM4s.js";
import { c as x, a as H } from "./BlockNoteExtension-C2X7LW-V.js";
import { syncPlugin as Oe } from "@y/prosemirror";
import { dropCursor as Me } from "prosemirror-dropcursor";
import { redo as Ae, undo as Re, history as Ne } from "@tiptap/pm/history";
import { Decoration as O, DecorationSet as L } from "prosemirror-view";
import { v4 as Le } from "uuid";
import { DOMParser as Ve, Slice as He } from "@tiptap/pm/model";
import { PluginKey as $e, TextSelection as Fe, Plugin as Ue } from "@tiptap/pm/state";
import { DOMSerializer as ie, Fragment as ae, Slice as ze } from "prosemirror-model";
import _e from "rehype-parse";
import Ke from "rehype-remark";
import Ye from "remark-gfm";
import je from "remark-stringify";
import { unified as Xe } from "unified";
import { fromDom as qe } from "hast-util-from-dom";
import { visit as We } from "unist-util-visit";
import { splitCell as Ge, mergeCells as Je, deleteRow as Qe, deleteColumn as Ze, addRowBefore as et, addRowAfter as tt, addColumnBefore as ot, addColumnAfter as nt, CellSelection as st } from "prosemirror-tables";
function le(s) {
  const e = Array.from(s.classList).filter(
    (t) => !t.startsWith("bn-")
  ) || [];
  e.length > 0 ? s.className = e.join(" ") : s.removeAttribute("class");
}
function de(s, e, t, o) {
  var a;
  let n;
  if (e)
    if (typeof e == "string")
      n = K([e], s.pmSchema);
    else if (Array.isArray(e))
      n = K(e, s.pmSchema);
    else if (e.type === "tableContent")
      n = Ce(e, s.pmSchema);
    else
      throw new ke(e.type);
  else throw new Error("blockContent is required");
  const i = ((o == null ? void 0 : o.document) ?? document).createDocumentFragment();
  for (const d of n)
    if (d.type.name !== "text" && s.schema.inlineContentSchema[d.type.name]) {
      const l = s.schema.inlineContentSpecs[d.type.name].implementation;
      if (l) {
        const m = xe(
          d,
          s.schema.inlineContentSchema,
          s.schema.styleSchema
        ), u = l.toExternalHTML ? l.toExternalHTML(
          m,
          s
        ) : l.render.call(
          {
            renderType: "dom",
            props: void 0
          },
          m,
          () => {
          },
          s
        );
        if (u) {
          if (i.appendChild(u.dom), u.contentDOM) {
            const f = t.serializeFragment(
              d.content,
              o
            );
            u.contentDOM.dataset.editable = "", u.contentDOM.appendChild(f);
          }
          continue;
        }
      }
    } else if (d.type.name === "text") {
      let l = document.createTextNode(
        d.textContent
      );
      for (const m of d.marks.toReversed())
        if (m.type.name in s.schema.styleSpecs) {
          const u = (s.schema.styleSpecs[m.type.name].implementation.toExternalHTML ?? s.schema.styleSpecs[m.type.name].implementation.render)(m.attrs.stringValue, s);
          u.contentDOM.appendChild(l), l = u.dom;
        } else {
          const u = m.type.spec.toDOM(m, !0), f = ie.renderSpec(document, u);
          f.contentDOM.appendChild(l), l = f.dom;
        }
      i.appendChild(l);
    } else {
      const l = t.serializeFragment(
        ae.from([d]),
        o
      );
      i.appendChild(l);
    }
  return i.childNodes.length === 1 && ((a = i.firstChild) == null ? void 0 : a.nodeType) === 1 && le(i.firstChild), i;
}
function rt(s, e, t, o, n, r, i) {
  var p, w, y, E, T, $, F, U, z;
  const a = (i == null ? void 0 : i.document) ?? document, d = e.pmSchema.nodes.blockContainer, l = t.props || {};
  for (const [v, k] of Object.entries(
    e.schema.blockSchema[t.type].propSchema
  ))
    !(v in l) && k.default !== void 0 && (l[v] = k.default);
  const m = (w = (p = d.spec) == null ? void 0 : p.toDOM) == null ? void 0 : w.call(
    p,
    d.create({
      id: t.id,
      ...l
    })
  ), u = Array.from(m.dom.attributes), f = e.blockImplementations[t.type].implementation, h = ((y = f.toExternalHTML) == null ? void 0 : y.call(
    {},
    { ...t, props: l },
    e
  )) || f.render.call(
    {},
    { ...t, props: l },
    e
  ), g = a.createDocumentFragment();
  if (h.dom.classList.contains("bn-block-content")) {
    const v = [
      ...u,
      ...Array.from(h.dom.attributes)
    ].filter(
      (k) => k.name.startsWith("data") && k.name !== "data-content-type" && k.name !== "data-file-block" && k.name !== "data-node-view-wrapper" && k.name !== "data-node-type" && k.name !== "data-id" && k.name !== "data-editable"
    );
    for (const k of v)
      h.dom.firstChild.setAttribute(k.name, k.value);
    le(h.dom.firstChild), g.append(...Array.from(h.dom.childNodes));
  } else
    g.append(h.dom);
  if (h.contentDOM && t.content) {
    const v = de(
      e,
      t.content,
      // TODO
      o,
      i
    );
    h.contentDOM.appendChild(v);
  }
  let c;
  if (n.has(t.type) ? c = "OL" : r.has(t.type) && (c = "UL"), c) {
    if (((E = s.lastChild) == null ? void 0 : E.nodeName) !== c) {
      const v = a.createElement(c);
      c === "OL" && "start" in l && l.start && (l == null ? void 0 : l.start) !== 1 && v.setAttribute("start", l.start + ""), s.append(v);
    }
    s.lastChild.appendChild(g);
  } else
    s.append(g);
  if (t.children && t.children.length > 0) {
    const v = a.createDocumentFragment();
    if (ce(
      v,
      e,
      t.children,
      o,
      n,
      r,
      i
    ), ((T = s.lastChild) == null ? void 0 : T.nodeName) === "UL" || (($ = s.lastChild) == null ? void 0 : $.nodeName) === "OL")
      for (; ((F = v.firstChild) == null ? void 0 : F.nodeName) === "UL" || ((U = v.firstChild) == null ? void 0 : U.nodeName) === "OL"; )
        s.lastChild.lastChild.appendChild(v.firstChild);
    e.pmSchema.nodes[t.type].isInGroup("blockContent") ? s.append(v) : (z = h.contentDOM) == null || z.append(v);
  }
}
const ce = (s, e, t, o, n, r, i) => {
  for (const a of t)
    rt(
      s,
      e,
      a,
      o,
      n,
      r,
      i
    );
}, it = (s, e, t, o, n, r) => {
  const a = ((r == null ? void 0 : r.document) ?? document).createDocumentFragment();
  return ce(
    a,
    s,
    e,
    t,
    o,
    n,
    r
  ), a;
}, he = (s, e) => {
  const t = ie.fromSchema(s);
  return {
    exportBlocks: (o, n) => {
      const r = it(
        e,
        o,
        t,
        /* @__PURE__ */ new Set(["numberedListItem"]),
        /* @__PURE__ */ new Set(["bulletListItem", "checkListItem", "toggleListItem"]),
        n
      ), i = document.createElement("div");
      return i.append(r), i.innerHTML;
    },
    exportInlineContent: (o, n) => {
      const r = de(
        e,
        o,
        t,
        n
      ), i = document.createElement("div");
      return i.append(r.cloneNode(!0)), i.innerHTML;
    }
  };
};
function at(s, e) {
  if (e === 0)
    return;
  const t = s.resolve(e);
  for (let o = t.depth; o > 0; o--) {
    const n = t.node(o);
    if (se(n))
      return n.attrs.id;
  }
}
function lt(s) {
  return s.getMeta("paste") ? { type: "paste" } : s.getMeta("uiEvent") === "drop" ? { type: "drop" } : s.getMeta("history$") ? {
    type: s.getMeta("history$").redo ? "redo" : "undo"
  } : s.getMeta("y-sync$") ? s.getMeta("y-sync$").isUndoRedoOperation ? { type: "undo-redo" } : { type: "yjs-remote" } : { type: "local" };
}
function q(s) {
  const e = "__root__", t = {}, o = {}, n = R(s);
  return s.descendants((r, i) => {
    if (!se(r))
      return !0;
    const a = at(s, i), d = a ?? e;
    o[d] || (o[d] = []);
    const l = N(r, n);
    return t[r.attrs.id] = { block: l, parentId: a }, o[d].push(r.attrs.id), !0;
  }), { byId: t, childrenByParent: o };
}
function dt(s, e) {
  const t = /* @__PURE__ */ new Set();
  if (!s || !e)
    return t;
  const o = new Set(s), n = e.filter((c) => o.has(c)), r = s.filter(
    (c) => n.includes(c)
  );
  if (r.length <= 1 || n.length <= 1)
    return t;
  const i = {};
  for (let c = 0; c < r.length; c++)
    i[r[c]] = c;
  const a = n.map((c) => i[c]), d = a.length, l = [], m = [], u = new Array(d).fill(-1), f = (c, p) => {
    let w = 0, y = c.length;
    for (; w < y; ) {
      const E = w + y >>> 1;
      c[E] < p ? w = E + 1 : y = E;
    }
    return w;
  };
  for (let c = 0; c < d; c++) {
    const p = a[c], w = f(l, p);
    w > 0 && (u[c] = m[w - 1]), w === l.length ? (l.push(p), m.push(c)) : (l[w] = p, m[w] = c);
  }
  const h = /* @__PURE__ */ new Set();
  let g = m[m.length - 1] ?? -1;
  for (; g !== -1; )
    h.add(g), g = u[g];
  for (let c = 0; c < n.length; c++)
    h.has(c) || t.add(n[c]);
  return t;
}
function ct(s, e = []) {
  const t = lt(s), o = we(s.before, [
    s,
    ...e
  ]), n = q(
    o.before
  ), r = q(
    o.doc
  ), i = [], a = /* @__PURE__ */ new Set();
  Object.keys(r.byId).filter((h) => !(h in n.byId)).forEach((h) => {
    i.push({
      type: "insert",
      block: r.byId[h].block,
      source: t,
      prevBlock: void 0
    }), a.add(h);
  }), Object.keys(n.byId).filter((h) => !(h in r.byId)).forEach((h) => {
    i.push({
      type: "delete",
      block: n.byId[h].block,
      source: t,
      prevBlock: void 0
    }), a.add(h);
  }), Object.keys(r.byId).filter((h) => h in n.byId).forEach((h) => {
    var w, y;
    const g = n.byId[h], c = r.byId[h];
    g.parentId !== c.parentId ? (i.push({
      type: "move",
      block: c.block,
      prevBlock: g.block,
      source: t,
      prevParent: g.parentId ? (w = n.byId[g.parentId]) == null ? void 0 : w.block : void 0,
      currentParent: c.parentId ? (y = r.byId[c.parentId]) == null ? void 0 : y.block : void 0
    }), a.add(h)) : ve(
      { ...g.block, children: void 0 },
      { ...c.block, children: void 0 }
    ) || (i.push({
      type: "update",
      block: c.block,
      prevBlock: g.block,
      source: t
    }), a.add(h));
  });
  const d = n.childrenByParent, l = r.childrenByParent, m = "__root__", u = /* @__PURE__ */ new Set([
    ...Object.keys(d),
    ...Object.keys(l)
  ]), f = /* @__PURE__ */ new Set();
  return u.forEach((h) => {
    const g = dt(
      d[h],
      l[h]
    );
    g.size !== 0 && g.forEach((c) => {
      var E, T;
      const p = n.byId[c], w = r.byId[c];
      !p || !w || p.parentId !== w.parentId || a.has(c) || (p.parentId ?? m) !== h || f.has(c) || (f.add(c), i.push({
        type: "move",
        block: w.block,
        prevBlock: p.block,
        source: t,
        prevParent: p.parentId ? (E = n.byId[p.parentId]) == null ? void 0 : E.block : void 0,
        currentParent: w.parentId ? (T = r.byId[w.parentId]) == null ? void 0 : T.block : void 0
      }), a.add(c));
    });
  }), i;
}
const Gt = x(() => {
  const s = [];
  return {
    key: "blockChange",
    prosemirrorPlugins: [
      new P({
        key: new B("blockChange"),
        filterTransaction: (e) => {
          let t;
          return s.reduce((o, n) => o === !1 ? o : n({
            getChanges() {
              return t || (t = ct(e), t);
            },
            tr: e
          }) !== !1, !0);
        }
      })
    ],
    /**
     * Subscribe to the block change events.
     */
    subscribe(e) {
      return s.push(e), () => {
        s.splice(
          s.indexOf(e),
          1
        );
      };
    }
  };
}), Jt = x(
  ({
    options: s
  }) => ({
    key: "ySync",
    prosemirrorPlugins: [
      Oe(s.fragment, {
        attributionManager: s.attributionManager,
        mapAttributionToMark(e, t) {
          var o, n;
          return t.delete ? Object.assign({}, e, {
            deletion: { id: Date.now(), user: (o = t.delete) == null ? void 0 : o[0] }
          }) : t.insert ? Object.assign({}, e, {
            insertion: { id: Date.now(), user: (n = t.insert) == null ? void 0 : n[0] }
          }) : e;
        }
      })
    ],
    runsBefore: ["default"]
  })
), Qt = x(
  ({
    editor: s,
    options: e
  }) => ({
    key: "dropCursor",
    prosemirrorPlugins: [
      (e.dropCursor ?? Me)({
        width: 5,
        color: "#ddeeff",
        editor: s
      })
    ]
  })
), Zt = x(({ editor: s }) => {
  const e = H(!1), t = () => s.transact((o) => {
    var r;
    if (o.selection.empty || o.selection instanceof ee && (o.selection.node.type.spec.content === "inline*" || ((r = o.selection.node.firstChild) == null ? void 0 : r.type.spec.content) === "inline*") || o.selection instanceof te && o.doc.textBetween(o.selection.from, o.selection.to).length === 0)
      return !1;
    let n = !1;
    return o.selection.content().content.descendants((i) => (i.type.spec.code && (n = !0), !n)), !n;
  });
  return {
    key: "formattingToolbar",
    store: e,
    mount({ dom: o, signal: n }) {
      let r = !1;
      const i = s.onChange(() => {
        r || e.setState(t());
      }), a = s.onSelectionChange(() => {
        r || e.setState(t());
      });
      o.addEventListener(
        "pointerdown",
        () => {
          r = !0, e.setState(!1);
        },
        { signal: n }
      ), s.prosemirrorView.root.addEventListener(
        "pointerup",
        () => {
          r = !1, s.isFocused() && e.setState(t());
        },
        { signal: n, capture: !0 }
      ), o.addEventListener(
        "pointercancel",
        () => {
          r = !1;
        },
        {
          signal: n,
          capture: !0
        }
      ), n.addEventListener("abort", () => {
        i(), a();
      });
    }
  };
}), eo = x(() => ({
  key: "history",
  prosemirrorPlugins: [Ne()],
  undoCommand: Re,
  redoCommand: Ae
})), to = x(({ editor: s }) => {
  function e(n) {
    let r = s.prosemirrorView.nodeDOM(n);
    for (; r && r.parentElement; ) {
      if (r.nodeName === "A")
        return r;
      r = r.parentElement;
    }
    return null;
  }
  function t(n, r) {
    return s.transact((i) => {
      const a = i.doc.resolve(n), d = a.marks().find((m) => m.type.name === r);
      if (!d)
        return;
      const l = ye(a, d.type);
      if (l)
        return {
          range: l,
          mark: d,
          get text() {
            return i.doc.textBetween(l.from, l.to);
          },
          get position() {
            return be(
              s.prosemirrorView,
              l.from,
              l.to
            ).toJSON();
          }
        };
    });
  }
  function o() {
    return s.transact((n) => {
      const r = n.selection;
      if (r.empty)
        return t(r.anchor, "link");
    });
  }
  return {
    key: "linkToolbar",
    getLinkAtSelection: o,
    getLinkElementAtPos: e,
    getMarkAtPos: t,
    getLinkAtElement(n) {
      return s.transact(() => {
        const r = s.prosemirrorView.posAtDOM(n, 0) + 1;
        return t(r, "link");
      });
    },
    editLink(n, r, i = s.transact((a) => a.selection.anchor)) {
      s.transact((a) => {
        const d = R(a), { range: l } = t(i + 1, "link") || {
          range: {
            from: a.selection.from,
            to: a.selection.to
          }
        };
        l && (a.insertText(r, l.from, l.to), a.addMark(
          l.from,
          l.from + r.length,
          d.mark("link", { href: n })
        ));
      }), s.prosemirrorView.focus();
    },
    deleteLink(n = s.transact((r) => r.selection.anchor)) {
      s.transact((r) => {
        const i = R(r), { range: a } = t(n + 1, "link") || {
          range: {
            from: r.selection.from,
            to: r.selection.to
          }
        };
        a && r.removeMark(a.from, a.to, i.marks.link).setMeta(
          "preventAutolink",
          !0
        );
      }), s.prosemirrorView.focus();
    }
  };
}), oo = [
  "http",
  "https",
  "ftp",
  "ftps",
  "mailto",
  "tel",
  "callto",
  "sms",
  "cid",
  "xmpp"
], no = "https", ht = new B("node-selection-keyboard"), so = x(
  () => ({
    key: "nodeSelectionKeyboard",
    prosemirrorPlugins: [
      new P({
        key: ht,
        props: {
          handleKeyDown: (s, e) => {
            if ("node" in s.state.selection) {
              if (e.ctrlKey || e.metaKey)
                return !1;
              if (e.key.length === 1)
                return e.preventDefault(), !0;
              if (e.key === "Enter" && !e.shiftKey && !e.altKey && !e.ctrlKey && !e.metaKey) {
                const t = s.state.tr;
                return s.dispatch(
                  t.insert(
                    s.state.tr.selection.$to.after(),
                    s.state.schema.nodes.paragraph.createChecked()
                  ).setSelection(
                    new te(
                      t.doc.resolve(
                        s.state.tr.selection.$to.after() + 1
                      )
                    )
                  )
                ), !0;
              }
            }
            return !1;
          }
        }
      })
    ]
  })
), ut = new B("blocknote-placeholder"), ro = x(
  ({
    editor: s,
    options: e
  }) => {
    const t = e.placeholders;
    return {
      key: "placeholder",
      prosemirrorPlugins: [
        new P({
          key: ut,
          view: (o) => {
            const n = `placeholder-selector-${Le()}`;
            o.dom.classList.add(n);
            const r = document.createElement("style"), i = s._tiptapEditor.options.injectNonce;
            i && r.setAttribute("nonce", i), o.root instanceof window.ShadowRoot ? o.root.append(r) : o.root.head.appendChild(r);
            const a = r.sheet, d = (l = "") => `.${n} .bn-block-content${l} .bn-inline-content:has(> .ProseMirror-trailingBreak:only-child):before`;
            try {
              const {
                default: l,
                emptyDocument: m,
                ...u
              } = t || {};
              for (const [g, c] of Object.entries(u)) {
                const p = `[data-content-type="${g}"]`;
                a.insertRule(
                  `${d(p)} { content: ${JSON.stringify(
                    c
                  )}; }`
                );
              }
              const f = "[data-is-only-empty-block]", h = "[data-is-empty-and-focused]";
              a.insertRule(
                `${d(f)} { content: ${JSON.stringify(
                  m
                )}; }`
              ), a.insertRule(
                `${d(h)} { content: ${JSON.stringify(
                  l
                )}; }`
              );
            } catch (l) {
              console.warn(
                "Failed to insert placeholder CSS rule - this is likely due to the browser not supporting certain CSS pseudo-element selectors (:has, :only-child:, or :before)",
                l
              );
            }
            return {
              destroy: () => {
                o.root instanceof window.ShadowRoot ? o.root.removeChild(r) : o.root.head.removeChild(r);
              }
            };
          },
          props: {
            decorations: (o) => {
              const { doc: n, selection: r } = o;
              if (!s.isEditable || !r.empty || r.$from.parent.type.spec.code)
                return;
              const i = [];
              o.doc.content.size === 6 && i.push(
                O.node(2, 4, {
                  "data-is-only-empty-block": "true"
                })
              );
              const a = r.$anchor, d = a.parent;
              if (d.content.size === 0) {
                const l = a.before();
                i.push(
                  O.node(l, l + d.nodeSize, {
                    "data-is-empty-and-focused": "true"
                  })
                );
              }
              return L.create(n, i);
            }
          }
        })
      ]
    };
  }
), W = new B("previous-blocks"), mt = {
  // Numbered List Items
  index: "index",
  // Headings
  level: "level",
  // All Blocks
  type: "type",
  depth: "depth",
  "depth-change": "depth-change"
}, io = x(() => {
  let s;
  return {
    key: "previousBlockType",
    prosemirrorPlugins: [
      new P({
        key: W,
        view(e) {
          return {
            update: async (t, o) => {
              var n;
              ((n = this.key) == null ? void 0 : n.getState(t.state).updatedBlocks.size) > 0 && (s = setTimeout(() => {
                t.dispatch(
                  t.state.tr.setMeta(W, { clearUpdate: !0 })
                );
              }, 0));
            },
            destroy: () => {
              s && clearTimeout(s);
            }
          };
        },
        state: {
          init() {
            return {
              // Block attributes, by block ID, from just before the previous transaction.
              prevTransactionOldBlockAttrs: {},
              // Block attributes, by block ID, from just before the current transaction.
              currentTransactionOldBlockAttrs: {},
              // Set of IDs of blocks whose attributes changed from the current transaction.
              updatedBlocks: /* @__PURE__ */ new Set()
            };
          },
          apply(e, t, o, n) {
            if (t.currentTransactionOldBlockAttrs = {}, t.updatedBlocks.clear(), !e.docChanged || o.doc.eq(n.doc))
              return t;
            const r = {}, i = _(
              o.doc,
              (l) => l.attrs.id
            ), a = new Map(
              i.map((l) => [l.node.attrs.id, l])
            ), d = _(
              n.doc,
              (l) => l.attrs.id
            );
            for (const l of d) {
              const m = a.get(l.node.attrs.id), u = m == null ? void 0 : m.node.firstChild, f = l.node.firstChild;
              if (m && u && f) {
                const h = {
                  index: f.attrs.index,
                  level: f.attrs.level,
                  type: f.type.name,
                  depth: n.doc.resolve(l.pos).depth
                }, g = {
                  index: u.attrs.index,
                  level: u.attrs.level,
                  type: u.type.name,
                  depth: o.doc.resolve(m.pos).depth
                };
                r[l.node.attrs.id] = g, t.currentTransactionOldBlockAttrs[l.node.attrs.id] = g, JSON.stringify(g) !== JSON.stringify(h) && (g["depth-change"] = g.depth - h.depth, t.updatedBlocks.add(l.node.attrs.id));
              }
            }
            return t.prevTransactionOldBlockAttrs = r, t;
          }
        },
        props: {
          decorations(e) {
            const t = this.getState(e);
            if (t.updatedBlocks.size === 0)
              return;
            const o = [];
            return e.doc.descendants((n, r) => {
              if (!n.attrs.id || !t.updatedBlocks.has(n.attrs.id))
                return;
              const i = t.currentTransactionOldBlockAttrs[n.attrs.id], a = {};
              for (const [l, m] of Object.entries(i))
                a["data-prev-" + mt[l]] = m || "none";
              const d = O.node(r, r + n.nodeSize, {
                ...a
              });
              o.push(d);
            }), L.create(e.doc, o);
          }
        }
      })
    ]
  };
});
function ue(s, e) {
  var t, o;
  for (; s && s.parentElement && s.parentElement !== e.dom && ((t = s.getAttribute) == null ? void 0 : t.call(s, "data-node-type")) !== "blockContainer"; )
    s = s.parentElement;
  if (((o = s.getAttribute) == null ? void 0 : o.call(s, "data-node-type")) === "blockContainer")
    return { node: s, id: s.getAttribute("data-id") };
}
function pt() {
  const s = (e) => {
    let t = e.children.length;
    for (let o = 0; o < t; o++) {
      const n = e.children[o];
      if (n.type === "element" && (s(n), n.tagName === "u"))
        if (n.children.length > 0) {
          e.children.splice(o, 1, ...n.children);
          const r = n.children.length - 1;
          t += r, o += r;
        } else
          e.children.splice(o, 1), t--, o--;
    }
  };
  return s;
}
function ft() {
  const s = (e) => {
    var t;
    if (e.children && "length" in e.children && e.children.length)
      for (let o = e.children.length - 1; o >= 0; o--) {
        const n = e.children[o], r = o + 1 < e.children.length ? e.children[o + 1] : void 0;
        n.type === "element" && n.tagName === "input" && ((t = n.properties) == null ? void 0 : t.type) === "checkbox" && (r == null ? void 0 : r.type) === "element" && r.tagName === "p" ? (r.tagName = "span", r.children.splice(
          0,
          0,
          qe(document.createTextNode(" "))
        )) : s(n);
      }
  };
  return s;
}
function gt() {
  return (s) => {
    We(s, "element", (e, t, o) => {
      var n, r, i, a;
      if (o && e.tagName === "video") {
        const d = ((n = e.properties) == null ? void 0 : n.src) || ((r = e.properties) == null ? void 0 : r["data-url"]) || "", l = ((i = e.properties) == null ? void 0 : i.title) || ((a = e.properties) == null ? void 0 : a["data-name"]) || "";
        o.children[t] = {
          type: "text",
          value: `![${l}](${d})`
        };
      }
    });
  };
}
function me(s) {
  return Xe().use(_e, { fragment: !0 }).use(gt).use(pt).use(ft).use(Ke).use(Ye).use(je, {
    handlers: { text: (t) => t.value }
  }).processSync(s).value;
}
function ao(s, e, t, o) {
  const r = he(e, t).exportBlocks(s, o);
  return me(r);
}
function wt(s) {
  const e = [];
  return s.descendants((t) => {
    var n, r;
    const o = R(t);
    return t.type.name === "blockContainer" && ((n = t.firstChild) == null ? void 0 : n.type.name) === "blockGroup" ? !0 : t.type.name === "columnList" && t.childCount === 1 ? ((r = t.firstChild) == null || r.forEach((i) => {
      e.push(N(i, o));
    }), !1) : t.type.isInGroup("bnBlock") ? (e.push(N(t, o)), !1) : !0;
  }), e;
}
class I extends A {
  constructor(t, o) {
    super(t, o);
    b(this, "nodes");
    const n = t.node();
    this.nodes = [], t.doc.nodesBetween(t.pos, o.pos, (r, i, a) => {
      if (a !== null && a.eq(n))
        return this.nodes.push(r), !1;
    });
  }
  static create(t, o, n = o) {
    return new I(t.resolve(o), t.resolve(n));
  }
  content() {
    return new ze(ae.from(this.nodes), 0, 0);
  }
  eq(t) {
    if (!(t instanceof I) || this.nodes.length !== t.nodes.length || this.from !== t.from || this.to !== t.to)
      return !1;
    for (let o = 0; o < this.nodes.length; o++)
      if (!this.nodes[o].eq(t.nodes[o]))
        return !1;
    return !0;
  }
  map(t, o) {
    const n = o.mapResult(this.from), r = o.mapResult(this.to);
    return r.deleted ? A.near(t.resolve(n.pos)) : n.deleted ? A.near(t.resolve(r.pos)) : new I(
      t.resolve(n.pos),
      t.resolve(r.pos)
    );
  }
  toJSON() {
    return { type: "multiple-node", anchor: this.anchor, head: this.head };
  }
}
A.jsonID("multiple-node", I);
let S;
function yt(s, e) {
  let t, o;
  const n = e.resolve(s.from).node().type.spec.group === "blockContent", r = e.resolve(s.to).node().type.spec.group === "blockContent", i = Math.min(s.$anchor.depth, s.$head.depth);
  if (n && r) {
    const a = s.$from.start(i - 1), d = s.$to.end(i - 1);
    t = e.resolve(a - 1).pos, o = e.resolve(d + 1).pos;
  } else
    t = s.from, o = s.to;
  return { from: t, to: o };
}
function G(s, e, t = e) {
  e === t && (t += s.state.doc.resolve(e + 1).node().nodeSize);
  const o = s.domAtPos(e).node.cloneNode(!0), n = s.domAtPos(e).node, r = (u, f) => Array.prototype.indexOf.call(u.children, f), i = r(
    n,
    // Expects from position to be just before the first selected block.
    s.domAtPos(e + 1).node.parentElement
  ), a = r(
    n,
    // Expects to position to be just after the last selected block.
    s.domAtPos(t - 1).node.parentElement
  );
  for (let u = n.childElementCount - 1; u >= 0; u--)
    (u > a || u < i) && o.removeChild(o.children[u]);
  pe(s.root), S = o;
  const d = S.getElementsByTagName("iframe");
  for (let u = 0; u < d.length; u++) {
    const f = d[u], h = f.parentElement;
    h && h.removeChild(f);
  }
  const m = s.dom.className.split(" ").filter(
    (u) => u !== "ProseMirror" && u !== "bn-root" && u !== "bn-editor"
  ).join(" ");
  S.className = S.className + " bn-drag-preview " + m, s.root instanceof ShadowRoot ? s.root.appendChild(S) : s.root.body.appendChild(S);
}
function pe(s) {
  S !== void 0 && (s instanceof ShadowRoot ? s.removeChild(S) : s.body.removeChild(S), S = void 0);
}
function bt(s, e, t) {
  if (!s.dataTransfer || t.headless)
    return;
  const o = t.prosemirrorView, n = re(e.id, o.state.doc);
  if (!n)
    throw new Error(`Block with ID ${e.id} not found`);
  const r = n.posBeforeNode;
  if (r != null) {
    const i = o.state.selection, a = o.state.doc, { from: d, to: l } = yt(i, a), m = d <= r && r < l, u = i.$anchor.node() !== i.$head.node() || i instanceof I;
    m && u ? (o.dispatch(
      o.state.tr.setSelection(I.create(a, d, l))
    ), G(o, d, l)) : (o.dispatch(
      o.state.tr.setSelection(ee.create(o.state.doc, r))
    ), G(o, r));
    const f = o.state.selection.content(), h = t.pmSchema, g = o.serializeForClipboard(f).dom.innerHTML, c = he(h, t), p = wt(f.content), w = c.exportBlocks(p, {}), y = me(w);
    s.dataTransfer.clearData(), s.dataTransfer.setData("blocknote/html", g), s.dataTransfer.setData("text/html", w), s.dataTransfer.setData("text/plain", y), s.dataTransfer.effectAllowed = "move", s.dataTransfer.setDragImage(S, 0, 0);
  }
}
const J = 250;
function V(s, e, t = !0) {
  const o = s.root.elementsFromPoint(e.left, e.top);
  for (const n of o)
    if (s.dom.contains(n))
      return t && n.closest("[data-node-type=columnList]") ? V(
        s,
        {
          // TODO can we do better than this?
          left: e.left + 50,
          // bit hacky, but if we're inside a column, offset x position to right to account for the width of sidemenu itself
          top: e.top
        },
        !1
      ) : ue(n, s);
}
function vt(s, e) {
  if (!e.dom.firstChild)
    return;
  const t = e.dom.firstChild.getBoundingClientRect(), o = {
    // Clamps the x position to the editor's bounding box.
    left: Math.min(
      Math.max(t.left + 10, s.x),
      t.right - 10
    ),
    top: s.y
  }, n = V(e, o);
  if (!n)
    return;
  const r = n.node.getBoundingClientRect();
  return V(
    e,
    {
      left: r.right - 10,
      top: s.y
    },
    !1
  );
}
class Ct {
  constructor(e, t, o) {
    b(this, "state");
    b(this, "emitUpdate");
    b(this, "mousePos");
    b(this, "hoveredBlock");
    b(this, "menuFrozen", !1);
    b(this, "isDragOrigin", !1);
    b(this, "updateState", (e) => {
      this.state = e, this.emitUpdate(this.state);
    });
    b(this, "updateStateFromMousePos", () => {
      var o, n, r, i, a;
      if (this.menuFrozen || !this.mousePos)
        return;
      const e = this.findClosestEditorElement({
        clientX: this.mousePos.x,
        clientY: this.mousePos.y
      });
      if ((e == null ? void 0 : e.element) !== this.pmView.dom || e.distance > J) {
        (o = this.state) != null && o.show && (this.state.show = !1, this.updateState(this.state));
        return;
      }
      const t = vt(this.mousePos, this.pmView);
      if (!t || !this.editor.isEditable) {
        (n = this.state) != null && n.show && (this.state.show = !1, this.updateState(this.state));
        return;
      }
      if (!((r = this.state) != null && r.show && ((i = this.hoveredBlock) != null && i.hasAttribute("data-id")) && ((a = this.hoveredBlock) == null ? void 0 : a.getAttribute("data-id")) === t.id) && (this.hoveredBlock = t.node, this.editor.isEditable)) {
        const d = t.node.getBoundingClientRect(), l = t.node.closest("[data-node-type=column]");
        this.state = {
          show: !0,
          referencePos: new DOMRect(
            l ? (
              // We take the first child as column elements have some default
              // padding. This is a little weird since this child element will
              // be the first block, but since it's always non-nested and we
              // only take the x coordinate, it's ok.
              l.firstElementChild.getBoundingClientRect().x
            ) : this.pmView.dom.firstChild.getBoundingClientRect().x,
            d.y,
            d.width,
            d.height
          ),
          block: this.editor.getBlock(
            this.hoveredBlock.getAttribute("data-id")
          )
        }, this.updateState(this.state);
      }
    });
    /**
     * If a block is being dragged, ProseMirror usually gets the context of what's
     * being dragged from `view.dragging`, which is automatically set when a
     * `dragstart` event fires in the editor. However, if the user tries to drag
     * and drop blocks between multiple editors, only the one in which the drag
     * began has that context, so we need to set it on the others manually. This
     * ensures that PM always drops the blocks in between other blocks, and not
     * inside them.
     *
     * After the `dragstart` event fires on the drag handle, it sets
     * `blocknote/html` data on the clipboard. This handler fires right after,
     * parsing the `blocknote/html` data into nodes and setting them on
     * `view.dragging`.
     *
     * Note: Setting `view.dragging` on `dragover` would be better as the user
     * could then drag between editors in different windows, but you can only
     * access `dataTransfer` contents on `dragstart` and `drop` events.
     */
    b(this, "onDragStart", (e) => {
      var i;
      const t = (i = e.dataTransfer) == null ? void 0 : i.getData("blocknote/html");
      if (!t || this.pmView.dragging)
        return;
      const o = document.createElement("div");
      o.innerHTML = t;
      const r = Ve.fromSchema(this.pmView.state.schema).parse(o, {
        topNode: this.pmView.state.schema.nodes.blockGroup.create()
      });
      this.pmView.dragging = {
        slice: new He(r.content, 0, 0),
        move: !0
      };
    });
    /**
     * Finds the closest editor visually to the given coordinates
     */
    b(this, "findClosestEditorElement", (e) => {
      const t = Array.from(this.pmView.root.querySelectorAll(".bn-editor"));
      if (t.length === 0)
        return null;
      let o = t[0], n = Number.MAX_VALUE;
      return t.forEach((r) => {
        const i = r.querySelector(".bn-block-group").getBoundingClientRect(), a = e.clientX < i.left ? i.left - e.clientX : e.clientX > i.right ? e.clientX - i.right : 0, d = e.clientY < i.top ? i.top - e.clientY : e.clientY > i.bottom ? e.clientY - i.bottom : 0, l = Math.sqrt(
          Math.pow(a, 2) + Math.pow(d, 2)
        );
        l < n && (n = l, o = r);
      }), {
        element: o,
        distance: n
      };
    });
    /**
     * This dragover event handler listens at the document level,
     * and is trying to handle dragover events for all editors.
     *
     * It specifically is trying to handle the following cases:
     *  - If the dragover event is within the bounds of any editor, then it does nothing
     *  - If the dragover event is outside the bounds of any editor, but close enough (within DISTANCE_TO_CONSIDER_EDITOR_BOUNDS) to the closest editor,
     *    then it dispatches a synthetic dragover event to the closest editor (which will trigger the drop-cursor to be shown on that editor)
     *  - If the dragover event is outside the bounds of the current editor, then it will dispatch a synthetic dragleave event to the current editor
     *    (which will trigger the drop-cursor to be removed from the current editor)
     *
     * The synthetic event is a necessary evil because we do not control prosemirror-dropcursor to be able to show the drop-cursor within the range we want
     */
    b(this, "onDragOver", (e) => {
      if (e.synthetic)
        return;
      const t = this.getDragEventContext(e);
      if (!t || !t.isDropPoint) {
        this.closeDropCursor();
        return;
      }
      t.isDropPoint && !t.isDropWithinEditorBounds && this.dispatchSyntheticEvent(e);
    });
    /**
     * Closes the drop-cursor for the current editor
     */
    b(this, "closeDropCursor", () => {
      const e = new Event("dragleave", { bubbles: !1 });
      e.synthetic = !0, this.pmView.dom.dispatchEvent(e);
    });
    /**
     * It is surprisingly difficult to determine the information we need to know about a drag event
     *
     * This function is trying to determine the following:
     *  - Whether the current editor instance is the drop point
     *  - Whether the current editor instance is the drag origin
     *  - Whether the drop event is within the bounds of the current editor instance
     */
    b(this, "getDragEventContext", (e) => {
      var d;
      const t = !((d = e.dataTransfer) != null && d.types.includes("blocknote/html")) && !!this.pmView.dragging, o = !!this.isDragOrigin, n = t || o, r = this.findClosestEditorElement(e);
      if (!r || r.distance > J)
        return;
      const i = r.element === this.pmView.dom, a = i && r.distance === 0;
      if (!(!i && !n))
        return {
          isDropPoint: i,
          isDropWithinEditorBounds: a,
          isDragOrigin: n
        };
    });
    /**
     * The drop event handler listens at the document level,
     * and handles drop events for all editors.
     *
     * It specifically handles the following cases:
     *  - If we are both the drag origin and drop point:
     *    - Let normal drop handling take over
     *  - If we are the drop point but not the drag origin:
     *    - Collapse selection to prevent PM from deleting unrelated content
     *    - If drop event is outside our editor bounds, dispatch synthetic drop event to our editor
     *  - If we are the drag origin but not the drop point:
     *    - Delete the dragged content from our editor after a delay
     */
    b(this, "onDrop", (e) => {
      if (e.synthetic)
        return;
      const t = this.getDragEventContext(e);
      if (!t) {
        this.closeDropCursor();
        return;
      }
      const { isDropPoint: o, isDropWithinEditorBounds: n, isDragOrigin: r } = t;
      if (!n && o && this.dispatchSyntheticEvent(e), o) {
        if (this.pmView.dragging)
          return;
        this.pmView.dispatch(
          this.pmView.state.tr.setSelection(
            Fe.create(
              this.pmView.state.tr.doc,
              this.pmView.state.tr.selection.anchor
            )
          )
        );
        return;
      } else if (r) {
        setTimeout(
          () => this.pmView.dispatch(this.pmView.state.tr.deleteSelection()),
          0
        );
        return;
      }
    });
    b(this, "onDragEnd", (e) => {
      e.synthetic || (this.pmView.dragging = null);
    });
    b(this, "onKeyDown", (e) => {
      var t;
      (t = this.state) != null && t.show && this.editor.isFocused() && (this.state.show = !1, this.emitUpdate(this.state));
    });
    b(this, "onMouseMove", (e) => {
      var r;
      if (this.menuFrozen)
        return;
      this.mousePos = { x: e.clientX, y: e.clientY };
      const t = this.pmView.dom.getBoundingClientRect(), o = this.mousePos.x > t.left && this.mousePos.x < t.right && this.mousePos.y > t.top && this.mousePos.y < t.bottom, n = this.pmView.dom.parentElement;
      if (
        // Cursor is within the editor area
        o && // An element is hovered
        e && e.target && // Element is outside the editor
        !(n === e.target || n.contains(e.target))
      ) {
        (r = this.state) != null && r.show && (this.state.show = !1, this.emitUpdate(this.state));
        return;
      }
      this.updateStateFromMousePos();
    });
    this.editor = e, this.pmView = t, this.emitUpdate = () => {
      if (!this.state)
        throw new Error("Attempting to update uninitialized side menu");
      o(this.state);
    }, this.pmView.root.addEventListener(
      "dragstart",
      this.onDragStart
    ), this.pmView.root.addEventListener(
      "dragover",
      this.onDragOver
    ), this.pmView.root.addEventListener(
      "drop",
      this.onDrop,
      !0
    ), this.pmView.root.addEventListener(
      "dragend",
      this.onDragEnd,
      !0
    ), this.pmView.root.addEventListener(
      "mousemove",
      this.onMouseMove,
      !0
    ), this.pmView.root.addEventListener(
      "keydown",
      this.onKeyDown,
      !0
    );
  }
  dispatchSyntheticEvent(e) {
    const t = new Event(e.type, e), o = this.pmView.dom.firstChild.getBoundingClientRect();
    t.clientX = e.clientX, t.clientY = e.clientY, t.clientX = Math.min(
      Math.max(e.clientX, o.left),
      o.left + o.width
    ), t.clientY = Math.min(
      Math.max(e.clientY, o.top),
      o.top + o.height
    ), t.dataTransfer = e.dataTransfer, t.preventDefault = () => e.preventDefault(), t.synthetic = !0, this.pmView.dom.dispatchEvent(t);
  }
  // Needed in cases where the editor state updates without the mouse cursor
  // moving, as some state updates can require a side menu update. For example,
  // adding a button to the side menu which removes the block can cause the
  // block below to jump up into the place of the removed block when clicked,
  // allowing the user to click the button again without moving the cursor. This
  // would otherwise not update the side menu, and so clicking the button again
  // would attempt to remove the same block again, causing an error.
  update(e, t) {
    var n;
    !t.doc.eq(this.pmView.state.doc) && ((n = this.state) != null && n.show) && this.updateStateFromMousePos();
  }
  destroy() {
    var e;
    (e = this.state) != null && e.show && (this.state.show = !1, this.emitUpdate(this.state)), this.pmView.root.removeEventListener(
      "mousemove",
      this.onMouseMove,
      !0
    ), this.pmView.root.removeEventListener(
      "dragstart",
      this.onDragStart
    ), this.pmView.root.removeEventListener(
      "dragover",
      this.onDragOver
    ), this.pmView.root.removeEventListener(
      "drop",
      this.onDrop,
      !0
    ), this.pmView.root.removeEventListener(
      "dragend",
      this.onDragEnd,
      !0
    ), this.pmView.root.removeEventListener(
      "keydown",
      this.onKeyDown,
      !0
    );
  }
}
const kt = new $e("SideMenuPlugin"), lo = x(({ editor: s }) => {
  let e;
  const t = H(
    void 0
  );
  return {
    key: "sideMenu",
    store: t,
    prosemirrorPlugins: [
      new Ue({
        key: kt,
        view: (o) => (e = new Ct(s, o, (n) => {
          t.setState({ ...n });
        }), e)
      })
    ],
    /**
     * Handles drag & drop events for blocks.
     */
    blockDragStart(o, n) {
      e && (e.isDragOrigin = !0), bt(o, n, s);
    },
    /**
     * Handles drag & drop events for blocks.
     */
    blockDragEnd() {
      pe(s.prosemirrorView.root), e && (e.isDragOrigin = !1), s.blur();
    },
    /**
     * Freezes the side menu. When frozen, the side menu will stay
     * attached to the same block regardless of which block is hovered by the
     * mouse cursor.
     */
    freezeMenu() {
      e.menuFrozen = !0, e.state.show = !0, e.emitUpdate(e.state);
    },
    /**
     * Unfreezes the side menu. When frozen, the side menu will stay
     * attached to the same block regardless of which block is hovered by the
     * mouse cursor.
     */
    unfreezeMenu() {
      e.menuFrozen = !1, e.state.show = !1, e.emitUpdate(e.state);
    }
  };
});
let C;
function Q(s) {
  C || (C = document.createElement("div"), C.innerHTML = "_", C.style.opacity = "0", C.style.height = "1px", C.style.width = "1px", s instanceof Document ? s.body.appendChild(C) : s.appendChild(C));
}
function xt(s) {
  C && (s instanceof Document ? s.body.removeChild(C) : s.removeChild(C), C = void 0);
}
function M(s) {
  return Array.prototype.indexOf.call(s.parentElement.childNodes, s);
}
function St(s) {
  let e = s;
  for (; e && e.nodeName !== "TD" && e.nodeName !== "TH" && !e.classList.contains("tableWrapper"); ) {
    if (e.classList.contains("ProseMirror"))
      return;
    const t = e.parentNode;
    if (!t || !(t instanceof Element))
      return;
    e = t;
  }
  return e.nodeName === "TD" || e.nodeName === "TH" ? {
    type: "cell",
    domNode: e,
    tbodyNode: e.closest("tbody")
  } : {
    type: "wrapper",
    domNode: e,
    tbodyNode: e.querySelector("tbody")
  };
}
function Et(s, e) {
  const t = e.querySelectorAll(s);
  for (let o = 0; o < t.length; o++)
    t[o].style.visibility = "hidden";
}
class It {
  constructor(e, t, o) {
    b(this, "state");
    b(this, "emitUpdate");
    b(this, "tableId");
    b(this, "tablePos");
    b(this, "tableElement");
    b(this, "menuFrozen", !1);
    b(this, "mouseState", "up");
    b(this, "prevWasEditable", null);
    b(this, "viewMousedownHandler", () => {
      this.mouseState = "down";
    });
    b(this, "mouseUpHandler", (e) => {
      this.mouseState = "up", this.mouseMoveHandler(e);
    });
    b(this, "mouseMoveHandler", (e) => {
      var l, m, u, f, h, g, c;
      if (this.menuFrozen || this.mouseState === "selecting" || !(e.target instanceof Element) || !this.pmView.dom.contains(e.target))
        return;
      const t = St(e.target);
      if ((t == null ? void 0 : t.type) === "cell" && this.mouseState === "down" && !((l = this.state) != null && l.draggingState)) {
        this.mouseState = "selecting", (m = this.state) != null && m.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
        return;
      }
      if (!t || !this.editor.isEditable) {
        (u = this.state) != null && u.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
        return;
      }
      if (!t.tbodyNode)
        return;
      const o = t.tbodyNode.getBoundingClientRect(), n = ue(t.domNode, this.pmView);
      if (!n)
        return;
      this.tableElement = n.node;
      let r;
      const i = this.editor.transact(
        (p) => re(n.id, p.doc)
      );
      if (!i)
        throw new Error(`Block with ID ${n.id} not found`);
      const a = N(
        i.node,
        this.editor.pmSchema,
        this.editor.schema.blockSchema,
        this.editor.schema.inlineContentSchema,
        this.editor.schema.styleSchema
      );
      if (De(this.editor, "table") && (this.tablePos = i.posBeforeNode + 1, r = a), !r)
        return;
      this.tableId = n.id;
      const d = (f = t.domNode.closest(".tableWrapper")) == null ? void 0 : f.querySelector(".table-widgets-container");
      if ((t == null ? void 0 : t.type) === "wrapper") {
        const p = e.clientY >= o.bottom - 1 && // -1 to account for fractions of pixels in "bottom"
        e.clientY < o.bottom + 20, w = e.clientX >= o.right - 1 && e.clientX < o.right + 20, y = e.clientX > o.right || e.clientY > o.bottom;
        this.state = {
          ...this.state,
          show: !0,
          showAddOrRemoveRowsButton: p,
          showAddOrRemoveColumnsButton: w,
          referencePosTable: o,
          block: r,
          widgetContainer: d,
          colIndex: y || (h = this.state) == null ? void 0 : h.colIndex,
          rowIndex: y || (g = this.state) == null ? void 0 : g.rowIndex,
          referencePosCell: y || (c = this.state) == null ? void 0 : c.referencePosCell
        };
      } else {
        const p = M(t.domNode), w = M(t.domNode.parentElement), y = t.domNode.getBoundingClientRect();
        if (this.state !== void 0 && this.state.show && this.tableId === n.id && this.state.rowIndex === w && this.state.colIndex === p)
          return;
        this.state = {
          show: !0,
          showAddOrRemoveColumnsButton: p === r.content.rows[0].cells.length - 1,
          showAddOrRemoveRowsButton: w === r.content.rows.length - 1,
          referencePosTable: o,
          block: r,
          draggingState: void 0,
          referencePosCell: y,
          colIndex: p,
          rowIndex: w,
          widgetContainer: d
        };
      }
      return this.emitUpdate(), !1;
    });
    b(this, "dragOverHandler", (e) => {
      var f;
      if (((f = this.state) == null ? void 0 : f.draggingState) === void 0)
        return;
      e.preventDefault(), e.dataTransfer.dropEffect = "move", Et(
        ".prosemirror-dropcursor-block, .prosemirror-dropcursor-inline",
        this.pmView.root
      );
      const t = {
        left: Math.min(
          Math.max(e.clientX, this.state.referencePosTable.left + 1),
          this.state.referencePosTable.right - 1
        ),
        top: Math.min(
          Math.max(e.clientY, this.state.referencePosTable.top + 1),
          this.state.referencePosTable.bottom - 1
        )
      }, o = this.pmView.root.elementsFromPoint(t.left, t.top).filter(
        (h) => h.tagName === "TD" || h.tagName === "TH"
      );
      if (o.length === 0)
        return;
      const n = o[0];
      let r = !1;
      const i = M(n.parentElement), a = M(n), d = this.state.draggingState.draggedCellOrientation === "row" ? this.state.rowIndex : this.state.colIndex, m = (this.state.draggingState.draggedCellOrientation === "row" ? i : a) !== d;
      (this.state.rowIndex !== i || this.state.colIndex !== a) && (this.state.rowIndex = i, this.state.colIndex = a, this.state.referencePosCell = n.getBoundingClientRect(), r = !0);
      const u = this.state.draggingState.draggedCellOrientation === "row" ? t.top : t.left;
      this.state.draggingState.mousePos !== u && (this.state.draggingState.mousePos = u, r = !0), r && this.emitUpdate(), m && this.editor.transact((h) => h.setMeta(D, !0));
    });
    b(this, "dropHandler", (e) => {
      if (this.mouseState = "up", this.state === void 0 || this.state.draggingState === void 0)
        return !1;
      if (this.state.rowIndex === void 0 || this.state.colIndex === void 0)
        throw new Error(
          "Attempted to drop table row or column, but no table block was hovered prior."
        );
      e.preventDefault();
      const { draggingState: t, colIndex: o, rowIndex: n } = this.state, r = this.state.block.content.columnWidths;
      if (t.draggedCellOrientation === "row") {
        if (!oe(
          this.state.block,
          t.originalIndex,
          n
        ))
          return !1;
        const i = Se(
          this.state.block,
          t.originalIndex,
          n
        );
        this.editor.updateBlock(this.state.block, {
          type: "table",
          content: {
            ...this.state.block.content,
            rows: i
          }
        });
      } else {
        if (!ne(
          this.state.block,
          t.originalIndex,
          o
        ))
          return !1;
        const i = Ee(
          this.state.block,
          t.originalIndex,
          o
        ), [a] = r.splice(t.originalIndex, 1);
        r.splice(o, 0, a), this.editor.updateBlock(this.state.block, {
          type: "table",
          content: {
            ...this.state.block.content,
            columnWidths: r,
            rows: i
          }
        });
      }
      return this.editor.setTextCursorPosition(this.state.block.id), !0;
    });
    this.editor = e, this.pmView = t, this.emitUpdate = () => {
      if (!this.state)
        throw new Error("Attempting to update uninitialized image toolbar");
      o(this.state);
    }, t.dom.addEventListener("mousemove", this.mouseMoveHandler), t.dom.addEventListener("mousedown", this.viewMousedownHandler), window.addEventListener("mouseup", this.mouseUpHandler), t.root.addEventListener(
      "dragover",
      this.dragOverHandler
    ), t.root.addEventListener(
      "drop",
      this.dropHandler
    );
  }
  // Updates drag handles when the table is modified or removed.
  update() {
    var n;
    if (!this.state || !this.state.show)
      return;
    if (this.state.block = this.editor.getBlock(this.state.block.id), !this.state.block || this.state.block.type !== "table" || // when collaborating, the table element might be replaced and out of date
    // because yjs replaces the element when for example you change the color via the side menu
    !((n = this.tableElement) != null && n.isConnected)) {
      this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate();
      return;
    }
    const { height: e, width: t } = Ie(
      this.state.block
    );
    this.state.rowIndex !== void 0 && this.state.colIndex !== void 0 && (this.state.rowIndex >= e && (this.state.rowIndex = e - 1), this.state.colIndex >= t && (this.state.colIndex = t - 1));
    const o = this.tableElement.querySelector("tbody");
    if (!o)
      throw new Error(
        "Table block does not contain a 'tbody' HTML element. This should never happen."
      );
    if (this.state.rowIndex !== void 0 && this.state.colIndex !== void 0) {
      const i = o.children[this.state.rowIndex].children[this.state.colIndex];
      i ? this.state.referencePosCell = i.getBoundingClientRect() : (this.state.rowIndex = void 0, this.state.colIndex = void 0);
    }
    this.state.referencePosTable = o.getBoundingClientRect(), this.emitUpdate();
  }
  destroy() {
    this.pmView.dom.removeEventListener("mousemove", this.mouseMoveHandler), window.removeEventListener("mouseup", this.mouseUpHandler), this.pmView.dom.removeEventListener("mousedown", this.viewMousedownHandler), this.pmView.root.removeEventListener(
      "dragover",
      this.dragOverHandler
    ), this.pmView.root.removeEventListener(
      "drop",
      this.dropHandler
    );
  }
}
const D = new B("TableHandlesPlugin"), co = x(({ editor: s }) => {
  let e;
  const t = H(void 0);
  return {
    key: "tableHandles",
    store: t,
    prosemirrorPlugins: [
      new P({
        key: D,
        view: (o) => (e = new It(s, o, (n) => {
          t.setState(
            n.block ? {
              ...n,
              draggingState: n.draggingState ? { ...n.draggingState } : void 0
            } : void 0
          );
        }), e),
        // We use decorations to render the drop cursor when dragging a table row
        // or column. The decorations are updated in the `dragOverHandler` method.
        props: {
          decorations: (o) => {
            if (e === void 0 || e.state === void 0 || e.state.draggingState === void 0 || e.tablePos === void 0)
              return;
            const n = e.state.draggingState.draggedCellOrientation === "row" ? e.state.rowIndex : e.state.colIndex;
            if (n === void 0)
              return;
            const r = [], { block: i, draggingState: a } = e.state, { originalIndex: d, draggedCellOrientation: l } = a;
            if (n === d || !i || l === "row" && !oe(i, d, n) || l === "col" && !ne(i, d, n))
              return L.create(o.doc, r);
            const m = o.doc.resolve(e.tablePos + 1);
            return e.state.draggingState.draggedCellOrientation === "row" ? j(
              e.state.block,
              n
            ).forEach(({ row: f, col: h }) => {
              const g = o.doc.resolve(
                m.posAtIndex(f) + 1
              ), c = o.doc.resolve(
                g.posAtIndex(h) + 1
              ), p = c.node(), w = c.pos + (n > d ? p.nodeSize - 2 : 0);
              r.push(
                // The widget is a small bar which spans the width of the cell.
                O.widget(w, () => {
                  const y = document.createElement("div");
                  return y.className = "bn-table-drop-cursor", y.style.left = "0", y.style.right = "0", n > d ? y.style.bottom = "-2px" : y.style.top = "-3px", y.style.height = "4px", y;
                })
              );
            }) : Y(
              e.state.block,
              n
            ).forEach(({ row: f, col: h }) => {
              const g = o.doc.resolve(
                m.posAtIndex(f) + 1
              ), c = o.doc.resolve(
                g.posAtIndex(h) + 1
              ), p = c.node(), w = c.pos + (n > d ? p.nodeSize - 2 : 0);
              r.push(
                // The widget is a small bar which spans the height of the cell.
                O.widget(w, () => {
                  const y = document.createElement("div");
                  return y.className = "bn-table-drop-cursor", y.style.top = "0", y.style.bottom = "0", n > d ? y.style.right = "-2px" : y.style.left = "-3px", y.style.width = "4px", y;
                })
              );
            }), L.create(o.doc, r);
          }
        }
      })
    ],
    /**
     * Callback that should be set on the `dragStart` event for whichever element
     * is used as the column drag handle.
     */
    colDragStart(o) {
      if (e === void 0 || e.state === void 0 || e.state.colIndex === void 0)
        throw new Error(
          "Attempted to drag table column, but no table block was hovered prior."
        );
      e.state.draggingState = {
        draggedCellOrientation: "col",
        originalIndex: e.state.colIndex,
        mousePos: o.clientX
      }, e.emitUpdate(), s.transact(
        (n) => n.setMeta(D, {
          draggedCellOrientation: e.state.draggingState.draggedCellOrientation,
          originalIndex: e.state.colIndex,
          newIndex: e.state.colIndex,
          tablePos: e.tablePos
        })
      ), !s.headless && (Q(s.prosemirrorView.root), o.dataTransfer.setDragImage(C, 0, 0), o.dataTransfer.effectAllowed = "move");
    },
    /**
     * Callback that should be set on the `dragStart` event for whichever element
     * is used as the row drag handle.
     */
    rowDragStart(o) {
      if (e.state === void 0 || e.state.rowIndex === void 0)
        throw new Error(
          "Attempted to drag table row, but no table block was hovered prior."
        );
      e.state.draggingState = {
        draggedCellOrientation: "row",
        originalIndex: e.state.rowIndex,
        mousePos: o.clientY
      }, e.emitUpdate(), s.transact(
        (n) => n.setMeta(D, {
          draggedCellOrientation: e.state.draggingState.draggedCellOrientation,
          originalIndex: e.state.rowIndex,
          newIndex: e.state.rowIndex,
          tablePos: e.tablePos
        })
      ), !s.headless && (Q(s.prosemirrorView.root), o.dataTransfer.setDragImage(C, 0, 0), o.dataTransfer.effectAllowed = "copyMove");
    },
    /**
     * Callback that should be set on the `dragEnd` event for both the element
     * used as the row drag handle, and the one used as the column drag handle.
     */
    dragEnd() {
      if (e.state === void 0)
        throw new Error(
          "Attempted to drag table row, but no table block was hovered prior."
        );
      e.state.draggingState = void 0, e.emitUpdate(), s.transact((o) => o.setMeta(D, null)), !s.headless && xt(s.prosemirrorView.root);
    },
    /**
     * Freezes the drag handles. When frozen, they will stay attached to the same
     * cell regardless of which cell is hovered by the mouse cursor.
     */
    freezeHandles() {
      e.menuFrozen = !0;
    },
    /**
     * Unfreezes the drag handles. When frozen, they will stay attached to the
     * same cell regardless of which cell is hovered by the mouse cursor.
     */
    unfreezeHandles() {
      e.menuFrozen = !1;
    },
    getCellsAtRowHandle(o, n) {
      return j(o, n);
    },
    /**
     * Get all the cells in a column of the table block.
     */
    getCellsAtColumnHandle(o, n) {
      return Y(o, n);
    },
    /**
     * Sets the selection to the given cell or a range of cells.
     * @returns The new state after the selection has been set.
     */
    setCellSelection(o, n, r = n) {
      if (!e)
        throw new Error("Table handles view not initialized");
      const i = o.doc.resolve(e.tablePos + 1), a = o.doc.resolve(
        i.posAtIndex(n.row) + 1
      ), d = o.doc.resolve(
        // No need for +1, since CellSelection expects the position before the cell
        a.posAtIndex(n.col)
      ), l = o.doc.resolve(
        i.posAtIndex(r.row) + 1
      ), m = o.doc.resolve(
        // No need for +1, since CellSelection expects the position before the cell
        l.posAtIndex(r.col)
      ), u = o.tr;
      return u.setSelection(
        new st(d, m)
      ), o.apply(u);
    },
    /**
     * Adds a row or column to the table using prosemirror-table commands
     */
    addRowOrColumn(o, n) {
      s.exec((r, i) => {
        const a = this.setCellSelection(
          r,
          n.orientation === "row" ? { row: o, col: 0 } : { row: 0, col: o }
        );
        return n.orientation === "row" ? n.side === "above" ? et(a, i) : tt(a, i) : n.side === "left" ? ot(a, i) : nt(a, i);
      });
    },
    /**
     * Removes a row or column from the table using prosemirror-table commands
     */
    removeRowOrColumn(o, n) {
      return n === "row" ? s.exec((r, i) => {
        const a = this.setCellSelection(r, {
          row: o,
          col: 0
        });
        return Qe(a, i);
      }) : s.exec((r, i) => {
        const a = this.setCellSelection(r, {
          row: 0,
          col: o
        });
        return Ze(a, i);
      });
    },
    /**
     * Merges the cells in the table block.
     */
    mergeCells(o) {
      return s.exec((n, r) => {
        const i = o ? this.setCellSelection(
          n,
          o.relativeStartCell,
          o.relativeEndCell
        ) : n;
        return Je(i, r);
      });
    },
    /**
     * Splits the cell in the table block.
     * If no cell is provided, the current cell selected will be split.
     */
    splitCell(o) {
      return s.exec((n, r) => {
        const i = o ? this.setCellSelection(n, o) : n;
        return Ge(i, r);
      });
    },
    /**
     * Gets the start and end cells of the current cell selection.
     * @returns The start and end cells of the current cell selection.
     */
    getCellSelection() {
      return s.transact((o) => {
        const n = o.selection;
        let r = n.$from, i = n.$to;
        if (X(n)) {
          const { ranges: c } = n;
          c.forEach((p) => {
            r = p.$from.min(r ?? p.$from), i = p.$to.max(i ?? p.$to);
          });
        } else if (r = o.doc.resolve(
          n.$from.pos - n.$from.parentOffset - 1
        ), i = o.doc.resolve(
          n.$to.pos - n.$to.parentOffset - 1
        ), r.pos === 0 || i.pos === 0)
          return;
        const a = o.doc.resolve(
          r.pos - r.parentOffset - 1
        ), d = o.doc.resolve(i.pos - i.parentOffset - 1), l = o.doc.resolve(a.pos - a.parentOffset - 1), m = r.index(a.depth), u = a.index(l.depth), f = i.index(d.depth), h = d.index(l.depth), g = [];
        for (let c = u; c <= h; c++)
          for (let p = m; p <= f; p++)
            g.push({ row: c, col: p });
        return {
          from: {
            row: u,
            col: m
          },
          to: {
            row: h,
            col: f
          },
          cells: g
        };
      });
    },
    /**
     * Gets the direction of the merge based on the current cell selection.
     *
     * Returns undefined when there is no cell selection, or the selection is not within a table.
     */
    getMergeDirection(o) {
      return s.transact((n) => {
        const r = X(n.selection) ? n.selection : void 0;
        if (!r || !o || // Only offer the merge button if there is more than one cell selected.
        r.ranges.length <= 1)
          return;
        const i = this.getCellSelection();
        if (i)
          return Te(i.from, i.to, o) ? "vertical" : "horizontal";
      });
    },
    cropEmptyRowsOrColumns(o, n) {
      return Be(o, n);
    },
    addRowsOrColumns(o, n, r) {
      return Pe(o, n, r);
    }
  };
}), Z = new B("trailingNode"), ho = x(() => ({
  key: "trailingNode",
  prosemirrorPlugins: [
    new P({
      key: Z,
      appendTransaction: (s, e, t) => {
        const { doc: o, tr: n, schema: r } = t, i = Z.getState(t), a = o.content.size - 2, d = r.nodes.blockContainer, l = r.nodes.paragraph;
        if (i)
          return n.insert(
            a,
            d.create(void 0, l.create())
          );
      },
      state: {
        init: (s, e) => {
        },
        apply: (s, e) => {
          if (!s.docChanged)
            return e;
          let t = s.doc.lastChild;
          if (!t || t.type.name !== "blockGroup")
            throw new Error("Expected blockGroup");
          if (t = t.lastChild, !t || t.type.name !== "blockContainer")
            return !0;
          const o = t.firstChild;
          if (!o)
            throw new Error("Expected blockContent");
          return t.nodeSize > 4 || o.type.spec.content !== "inline*";
        }
      }
    })
  ]
}));
export {
  Gt as B,
  Qt as D,
  Zt as F,
  eo as H,
  to as L,
  so as N,
  ro as P,
  Ct as S,
  It as T,
  oo as V,
  Jt as Y,
  no as a,
  io as b,
  lo as c,
  co as d,
  ho as e,
  he as f,
  ct as g,
  ao as h,
  me as i,
  wt as j,
  kt as s,
  D as t
};
//# sourceMappingURL=TrailingNode-rLvSyRLT.js.map
